import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/Home.vue";
import GuestDetails from "../views/GuestDetails.vue";
import Vehicles from "../views/Vehicles.vue";
import Extras from "../views/Extras.vue";
import TravelAndInsurance from "../views/TravelAndInsurance.vue";
import DiscountsAndOffers from "../views/DiscountsAndOffers.vue";
import SummaryAndConfirmation from "../views/SummaryAndConfirmation.vue";
import store from '../store/index';

const routes = [
    {
        path: "/",
        name: "Home",
        component: Home
    },
    {
        path: "/guest-details",
        name: "GuestDetails",
        component: GuestDetails,
            beforeEnter: (to, from, next) => {
                if (store.state.progressStep < 1 && !process.env.VUE_APP_DEBUG) {
                    next({
                        path: '/'
                    })
                } else {
                    next()
                }
            }
    },
    {
        path: "/vehicles",
        name: "Vehicles",
        component: Vehicles,
            beforeEnter: (to, from, next) => {
                if (store.state.progressStep < 1 && !process.env.VUE_APP_DEBUG) {
                    next({
                        path: '/'
                    })
                } else {
                    next()
                }
            }
    },
    {
        path: "/extras",
        name: "Extras",
        component: Extras,
            beforeEnter: (to, from, next) => {
                if (store.state.progressStep < 2 && !process.env.VUE_APP_DEBUG) {
                    next({
                        path: '/'
                    })
                } else {
                    next()
                }
            }
    },
    {
        path: "/travel-and-insurance",
        name: "TravelAndInsurance",
        component: TravelAndInsurance,
            beforeEnter: (to, from, next) => {
                if (store.state.progressStep < 3 && !process.env.VUE_APP_DEBUG) {
                    next({
                        path: '/'
                    })
                } else {
                    next()
                }
            }
    },
    {
        path: "/discounts-and-offers",
        name: "DiscountsAndOffers",
        component: DiscountsAndOffers,
            beforeEnter: (to, from, next) => {
                if (store.state.progressStep < 4 && !process.env.VUE_APP_DEBUG) {
                    next({
                        path: '/'
                    })
                } else {
                    next()
                }
            }
    },
    {
        path: "/summary-and-confirmation",
        name: "SummaryAndConfirmation",
        component: SummaryAndConfirmation,
            beforeEnter: (to, from, next) => {
                if (store.state.progressStep < 5 && !process.env.VUE_APP_DEBUG) {
                    next({
                        path: '/'
                    })
                } else {
                    next()
                }
            }
    }
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior(to, from, savedPosition) {
        // console.log('to',to);
        // console.log('from',from);
        // console.log('savedPosition',savedPosition);
        if (savedPosition) {
            return savedPosition;
        }
        if (to.hash) {
            return {
                el: to.hash
            };
        }
        return {
            x: 0,
            y: 0
        };
    }
});

export default router;
